module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3eb016636cb3c47144c46e5fa67ad508.png";